import api from "../api/api";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  DeleteOutlined,
  DownloadOutlined,
  PaperClipOutlined,
  SearchOutlined,
  InboxOutlined,
  FileTextOutlined,
  CalendarOutlined,
} from "@ant-design/icons";

import {
  Card,
  Table,
  Button,
  Typography,
  Input,
  Space,
  Row,
  Col,
  Statistic,
  Skeleton,
  Empty,
  Popconfirm,
} from "antd";



const TestAttachmentView = () => {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");



  const fetchAttachments = async () => {
    setLoading(true);
    try {
      const res = await api.get("/attachments/");
      setAttachments(res.data);
    } catch (error) {
      Swal.fire("Error", "Failed to fetch attachments.", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAttachments();
  }, []);

  const handleDownload = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileUrl.split("/").pop();
    link.click();
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the attachment.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete("/attachments/", { data: { id } });
          Swal.fire(
            "Deleted!",
            "Attachment deleted successfully.",
            "success"
          );
          fetchAttachments();
        } catch (error) {
          Swal.fire("Error", "Failed to delete attachment.", "error");
        }
      }
    });
  };

  const columns = [
{
title: "Title",
dataIndex: "title",
key: "title",
render: (text) => (
<Space>
<FileTextOutlined
style={{
color:"#800000",
fontSize:18
}}
/>
<Text strong>{text}</Text>
</Space>
),
},

{
title:"Description",
dataIndex:"description",
key:"description",
render:(text)=>text || "-",
},

{
title:"Attachment",
key:"file",
render:(_,record)=>(
<Button
type="link"
icon={<DownloadOutlined />}
onClick={()=>handleDownload(record.file_url)}
>
Download
</Button>
),
},

{
title:"Uploaded",
dataIndex:"uploaded_at",
key:"uploaded_at",
render:(date)=>(
<Space>
<CalendarOutlined/>
{new Date(date).toLocaleString()}
</Space>
),
},

{
title:"Action",
key:"action",
align:"center",

render:(_,record)=>(
<Popconfirm
title="Delete Attachment?"
description="This action cannot be undone."
okText="Delete"
cancelText="Cancel"
okButtonProps={{
danger:true
}}
onConfirm={()=>handleDelete(record.id)}
>

<Button
danger
icon={<DeleteOutlined/>}
>
Delete
</Button>

</Popconfirm>
)

}
];

  // Filter attachments by search term
  const filteredAttachments = attachments.filter((file) =>
    file.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
const { Title, Text } = Typography;

return(

<div
  style={{
    padding: 25,
    background: "transparent",
    minHeight: "100vh",
  }}
>

<Card
bordered={false}
style={{
borderRadius:18,
boxShadow:"0 10px 30px rgba(0,0,0,.08)"
}}
>

<Space
direction="vertical"
size={3}
style={{
width:"100%",
marginBottom:25
}}
>

<Title
level={3}
style={{
margin:0,
display:"flex",
alignItems:"center",
gap:10,
color:"#800000"
}}
>

<PaperClipOutlined/>

Test Attachments

</Title>

<Text type="secondary">

Manage, download and remove examination attachments.

</Text>

</Space>

<Row gutter={16} style={{marginBottom:25}}>

<Col xs={24} md={8}>
<Card bordered={false} style={{background:"#fafafa"}}>
<Statistic
title="Attachments"
value={attachments.length}
prefix={<InboxOutlined style={{color:"#800000"}}/>}
/>
</Card>
</Col>

<Col xs={24} md={8}>
<Card bordered={false} style={{background:"#fafafa"}}>
<Statistic
title="Filtered"
value={filteredAttachments.length}
prefix={<SearchOutlined style={{color:"#1890ff"}}/>}
/>
</Card>
</Col>

<Col xs={24} md={8}>
<Card bordered={false} style={{background:"#fafafa"}}>
<Statistic
title="Downloads"
value={attachments.length}
prefix={<DownloadOutlined style={{color:"#52c41a"}}/>}
/>
</Card>
</Col>

</Row>

<Input
allowClear
size="large"
prefix={<SearchOutlined/>}
placeholder="Search attachment title..."
value={searchTerm}
onChange={(e)=>setSearchTerm(e.target.value)}
style={{
marginBottom:20,
maxWidth:450
}}
/>

{
loading ?

<Skeleton active paragraph={{rows:8}}/>

:

<Table

columns={columns}

dataSource={filteredAttachments}

rowKey="id"

pagination={{
pageSize:10,
showSizeChanger:true
}}

scroll={{
x:1000
}}

locale={{
emptyText:<Empty description="No Attachments Found"/>
}}

style={{
borderRadius:12
}}

/>

}

</Card>

</div>

);
};

export default TestAttachmentView;
